import React, { useContext, useRef, useEffect } from 'react';
import FalconContext from '../contexts/falcon.context';
import SmokeMachine from '@bijection/smoke';

const useCanvas = callback => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas: any = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      callback([canvas, ctx]);
    }
  }, []);

  return canvasRef;
};

const Smoke = props => {
  let canvasRef;
  const { className } = props;
  const falconState = useContext(FalconContext);
  const showStates = ['engineIgnition', 'countDownTMinus1', 'liftoff'];
  const showSmoke = showStates.includes(falconState.state);

  if (showSmoke) {
    canvasRef = useCanvas(([canvas, ctx]) => {
      console.log('CANVAS REF: ', canvas, ctx);

      const smokeCreator = SmokeMachine(ctx, [120, 120, 120]);

      setTimeout(() => {
        smokeCreator.stop(); // stop animating

        Array.from(Array(6)).forEach((elem, idx) => {
          smokeCreator.addSmoke(idx * 200, 700, 1000);
        });

        for (let i = 0; i < 10; i++) {
          smokeCreator.step(100); // pretend 10 ms pass and rerender
        }

        setTimeout(() => {
          smokeCreator.start();
        }, 3000);
      }, 1);
    });
  }

  return true ? (
    <canvas
      ref={canvasRef}
      width={1000}
      height={700}
      style={{ position: 'absolute', left: '-480px', bottom: 0 }}
    />
  ) : null;
};

export default Smoke;
